import { useState } from 'react'
import { ReactNode } from 'react'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { cn } from '@/lib/utils'

interface LayoutProps {
  children: ReactNode
  className?: string
}

export function Layout({ children, className }: LayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  
  const toggleSidebar = () => setSidebarCollapsed(!sidebarCollapsed)

  return (
    <div className="relative flex min-h-screen flex-col bg-background">
      {/* Header */}
      <Header onMenuClick={toggleSidebar} />
      
      <div className="flex flex-1">
        {/* Sidebar */}
        <Sidebar collapsed={sidebarCollapsed} onToggle={toggleSidebar} />
        
        {/* Main content */}
        <main className={cn(
          "flex-1 overflow-y-auto p-4 md:p-6 lg:p-8",
          sidebarCollapsed ? "ml-0" : "ml-0 md:ml-64",
          className
        )}>
          <div className="mx-auto max-w-7xl">
            {children}
          </div>
        </main>
      </div>
    </div>
  )
}
